/**
 * @description
 * @author librajt
 * @date
 */

import React, { Component } from 'react';

import { displayUserLevel, getUserLevelColorScheme } from '../../../@utils/userAchievementUtil';
import { classSet } from '@umu/umu-dom';
import './userLevelBadge.scss';

export type TUserLevelSize = 'M' | 'L' | 'S' | undefined;

interface IUserLevelBadgeProps {
    userLevelSize?: TUserLevelSize;
    userLevelInfo: number;
    isTransformPx2Rem?: boolean;
}
const isInUSE = (window as any).isInUSE || window.location.pathname.startsWith('/use')
export default class UserLevelBadge extends Component<IUserLevelBadgeProps, {}> {
    public render() {
        if (isInUSE) {
            return null;
        }
        const { userLevelInfo, userLevelSize, isTransformPx2Rem = true } = this.props;

        const lvColorScheme = getUserLevelColorScheme(userLevelInfo, true);

        const size = userLevelSize ? ' size-' + userLevelSize : '';
        const classNames = classSet({
            'user-level-badge': true,
            'keep-px': !isTransformPx2Rem,
            [size]: !!size,
        });

        return (
            <div className={classNames} style={{ backgroundColor: lvColorScheme.primary }}>
                <div className="user-level" style={{ color: lvColorScheme.secondary }}>
                    {displayUserLevel(userLevelInfo)}
                </div>
            </div>
        );
    }
}
